module.exports = __webpack_public_path__ + "static/img/education-300x300.92f8fc36.jpg";